export default __webpack_public_path__ + "static/media/laboratorioClinico.76443e3c.jpg";